import Vue from "vue";
// import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AppComp from "./components";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "./app.scss";
import Directive from "@/utils/directive"
import filters from "@/utils/filters"
import EnumSelect from '@/components/EnumSelect'
import Upload from '@/components/Upload'
import * as utils from '@/utils/utils'
import "@/assets/css/style.css";
import "@/assets/css/app.css";
import '@/assets/icon/iconfont.css'


import Print from 'vue-print-nb'
Vue.use(Print);
Vue.use(filters);
Vue.use(ElementUI);
Vue.use(BootstrapVue);
//https://bootstrap-vue.org/docs/icons/
Vue.use(BootstrapVueIcons);
Vue.use(AppComp);
Vue.use(Directive)
Vue.component('enum-select', EnumSelect)
Vue.component('Upload', Upload)

import http from '@/plugins/request';
Vue.prototype.$http = http;


Vue.config.productionTip = false;
Vue.prototype.$utils = utils;
import websocket from '@/utils/webSocket';
Vue.prototype.$websocket = websocket;
const $root = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
window.$root = $root;
